import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { IComponentV2 } from '../../interfaces';
import { useRatesFilterParams } from '../../hooks';
import { cleanRatesStore, getMyPurchasesList, setRatesIsV2 } from '../../middleware';
import { SalesRatesListTable } from './Components';

export const SalesRatesList: React.FC<IComponentV2> = observer(({ isV2 }: IComponentV2) => {
    const filterParams = useRatesFilterParams();

    useEffect(() => {
        getMyPurchasesList();
    }, []);

    useEffect(() => {
        setRatesIsV2(isV2);
    }, [isV2]);

    return (
        <Catcher>
            <ListWrapper cleanStore={cleanRatesStore} filterParams={filterParams}>
                <SalesRatesListTable />
            </ListWrapper>
        </Catcher>
    );
});
